// 防抖函数
function debounce(func, delay = 300) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default {
  bind(el, binding) {
    const selectDropdown = el.querySelector('.el-select-dropdown .el-scrollbar__wrap');
    if (!selectDropdown) return;

    const loadMore = debounce(() => {
      if (selectDropdown.scrollHeight - selectDropdown.scrollTop <= selectDropdown.clientHeight) {
        binding.value();
      }
    });

    selectDropdown.addEventListener('scroll', loadMore);
    el._onScroll = loadMore;
  },

  unbind(el) {
    const selectDropdown = el.querySelector('.el-select-dropdown .el-scrollbar__wrap');
    if (selectDropdown && el._onScroll) {
      selectDropdown.removeEventListener('scroll', el._onScroll);
      delete el._onScroll;
    }
  },
};